<h1 mat-dialog-title class="mat-headline">Verträge auswählen</h1>
<div mat-dialog-content class="content">
    <div class="scrollbar-wrapper">
        <ngx-simplebar>
            <table mat-table [dataSource]="DisplayContracts$">
                <ng-container matColumnDef="icon">
                    <td mat-cell *matCellDef="let rowData">
                        <fa-icon icon="times" size="lg" *ngIf="!rowData.Selected"></fa-icon>
                        <fa-icon icon="check" size="lg" *ngIf="rowData.Selected"></fa-icon>
                    </td>
                </ng-container>
                <ng-container matColumnDef="name">
                    <td mat-cell *matCellDef="let rowData">
                        {{ rowData.Contract.Name }}
                    </td>
                </ng-container>
                <tr
                        mat-row
                        *matRowDef="let rowData; columns: ['icon', 'name']"
                        (click)="ToggleSelected(rowData.Contract.Id)"
                >
                </tr>
            </table>
        </ngx-simplebar>
    </div>
</div>
<div mat-dialog-actions class="buttons">
<!--    <button app-button class="button" (click)="SelectAll()">Alle Auswählen</button>-->
    <button app-button class="button" (click)="Save()">Speichern</button>
    <button app-button class="button" (click)="Close()">Schließen</button>
</div>
